import { render } from "./hardware-logs-page.vue?vue&type=template&id=efb1f210"
import script from "./hardware-logs-page.vue?vue&type=script&lang=ts"
export * from "./hardware-logs-page.vue?vue&type=script&lang=ts"

import "./hardware-logs-page.vue?vue&type=style&index=0&id=efb1f210&lang=less"
script.render = render

export default script